import WebAPI from './api-calls';

const webApi = new WebAPI();

export async function fetchCustomerSites() {
    const response = await webApi.getFromWebApiWithAccessTokenAsync('/api/multiutility/customer-sites');
    return response.data;
}
